/*
import 'flickity/dist/flickity.pkgd.min.js';
import 'flickity-bg-lazyload';


export default {
  init() {


    var $hero = $('.main-carousel').flickity({
      bgLazyLoad: true,
      wrapAround: false,
      accessibility: true,
      prevNextButtons: true,
      pageDots: true,
      setGallerySize: false,
      cellAlign: 'left',
      arrowShape: {
        x0: 10,
        x1: 60,
        y1: 50,
        x2: 60,
        y2: 45,
        x3: 15,
      },
    });
    $hero.flickity();


  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
*/



// WEBPACK FOOTER //
// ./scripts/routes/home.js